import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { Box, Typography } from "@mui/material";
import { Edit, FormDataConsumer, ReferenceField, ReferenceInput, SelectInput, SimpleForm, TextField, TextInput, } from "react-admin";
import { ListBallotStyle } from "./ListBallotStyle";
import { JsonInput } from "react-admin-json-view";
var BallotStyleForm = function () {
    return (_jsx(Box, { sx: { flexGrow: 2, flexShrink: 0 }, children: _jsxs(SimpleForm, { children: [_jsx(Typography, { variant: "h4", children: "Ballot Style" }), _jsx(Typography, { variant: "body2", children: "Ballot Style configuration" }), _jsx(Typography, { variant: "h5", children: "ID" }), _jsx(TextField, { source: "id" }), _jsx(TextInput, { source: "ballot_eml" }), _jsx(TextInput, { source: "status" }), _jsx(Typography, { variant: "h5", children: "Election" }), _jsx(ReferenceField, { label: "Election", reference: "sequent_backend_election", source: "election_id", children: _jsx(TextField, { source: "name" }) }), _jsx(Typography, { variant: "h5", children: "Election Event" }), _jsx(ReferenceField, { label: "Election Event", reference: "sequent_backend_election_event", source: "election_event_id", children: _jsx(TextField, { source: "name" }) }), _jsx(FormDataConsumer, { children: function (_a) {
                        var formData = _a.formData;
                        return (_jsx(ReferenceInput, { source: "area_id", reference: "sequent_backend_area", filter: {
                                tenant_id: formData.tenant_id,
                                election_event_id: formData.election_event_id,
                            }, children: _jsx(SelectInput, { optionText: "name" }) }));
                    } }), _jsx(JsonInput, { source: "labels", jsonString: false, reactJsonOptions: {
                        name: null,
                        collapsed: true,
                        enableClipboard: true,
                        displayDataTypes: false,
                    } }), _jsx(JsonInput, { source: "annotations", jsonString: false, reactJsonOptions: {
                        name: null,
                        collapsed: true,
                        enableClipboard: true,
                        displayDataTypes: false,
                    } }), _jsx(JsonInput, { source: "status", jsonString: false, reactJsonOptions: {
                        name: null,
                        collapsed: true,
                        enableClipboard: true,
                        displayDataTypes: false,
                    } })] }) }));
};
export var EditBallotStyle = function () {
    return (_jsx(ListBallotStyle, { aside: _jsx(Edit, { sx: { flexGrow: 2, width: "50%", flexShrink: 0 }, children: _jsx(BallotStyleForm, {}) }) }));
};
